import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";

const { forwardRef, useRef, useImperativeHandle } = React;

const RolesSelect = forwardRef(({ oldRoles, onChange, label }, ref) => {
  const { utils } = useSelector(utilsState);

  const [rolesOption, setRolesOption] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedRoles([]);
    },
  }));

  useEffect(() => {
    if (utils?.ROLES) {
      let RolesArray = Object.values(utils.ROLES);
      let newRoles = [];
      RolesArray?.map((item) =>
        newRoles.push({
          value: item.value,
          label: item.name,
        })
      );
      setRolesOption(newRoles);
    }
  }, [utils]);

  function handleRoles(data) {
    setSelectedRoles(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  useEffect(() => {
    if (oldRoles?.length > 0 && utils?.ROLES_VALUES?.length) {
      // let RolesArray = Object.values(utils?.ROLES);
      let selectedRoles = [];
      for (let i = 0; i < oldRoles?.length; i++) {
        let isExist = utils?.ROLES_VALUES.filter((item) => {
          return item.value == oldRoles[i];
        });
        selectedRoles.push({
          value: isExist[0]?.value,
          label: isExist[0]?.name,
        });
        console.log(isExist);
      }
      console.log(selectedRoles);
      setSelectedRoles(selectedRoles);
    }
  }, [oldRoles, utils]);

  return (
    <div>
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label}
      </label>
      <Select
        classNamePrefix="admin-select"
        isRtl
        className=""
        options={rolesOption}
        placeholder="انتخاب نقش"
        value={selectedRoles}
        onChange={handleRoles}
        isSearchable={true}
        isMulti
      />
    </div>
  );
});

export default RolesSelect;
